
export const showInfo = infoMessage => {
  window.notify.open({ type: 'info', message: infoMessage.text} );
}

export const showError = errorMessage => {
  window.notify.open({ type: 'error', message: errorMessage });
}

export const showWarning = warningMessage => {
  window.notify.open({ type: 'warning', message: warningMessage });
}

export default {
  showInfo,
  showError,
  showWarning
}
